import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { AppointmentModalComponent } from '../components/appointment-modal/appointment-modal.component';
import { FilterModalComponent } from '../components/filter-modal/filter-modal.component';
import { DOCUMENT } from '@angular/common';
import { environment } from '@env/environment';
import { Encrypt } from '../../utils/encrypt/encrypt';
import { CookieCiencuadras } from '../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { ProductsService } from '../../services/products/products.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CcLoginComponent, CcRegisterComponent, PasswordRecoverComponent } from 'cc-components-lib';
@Component({
  selector: 'app-products-user-zone',
  templateUrl: './products-user-zone.component.html',
  styleUrls: ['./products-user-zone.component.scss']
})
export class ProductsUserZoneComponent implements OnInit {

  currentTab: number = 0;
  userType: number = 0;
  public ccEnvironment: any;

  constructor(
    private dialog: MatDialog,
    private cookieCiencuadras: CookieCiencuadras,
    private productsService: ProductsService,
    @Inject(DOCUMENT) private document: any,
    private dialogLogin: MatDialog
    ) { 
      this.ccEnvironment = environment;
     }

    async ngOnInit(): Promise<void> {​​
      await this.getUserInformation();
      console.log('userType: ', this.userType);
      this.changeTab(1);
    }

  async getUserInformation(){
    
    let cripto = new Encrypt();
    console.log('---------- getUserInformation() ----------');
    console.log('this.cookieCiencuadras.getCookie(user_id)', this.cookieCiencuadras.getCookie('user_id'));
    console.log('this.cookieCiencuadras.getCookie(user_id) decryptDataIV: ', cripto.decryptDataIV(this.cookieCiencuadras.getCookie('user_id')));
    console.log('localStorage.getItem(currentUser)', localStorage.getItem('currentUser'));
    console.log('localStorage.getItem(currentUser) decryptDataIV: ', cripto.decryptDataIV(localStorage.getItem('currentUser')));
    let user_id: string = this.cookieCiencuadras.getCookie('user_id') ? this.cookieCiencuadras.getCookie('user_id') : localStorage.getItem('currentUser');
    console.log('---------- getUserInformation() ----------');

    return new Promise((resolve) => {
      this.productsService.getUserInformation(
        user_id
      ).pipe().subscribe(res => {
        console.log('------------------', res);
        if (res.status) {
          console.log('userInformation: ', res.data);
          this.userType = res.data.typeUser;
          resolve(true);
        }
        resolve(false);
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('An error occurred:', err.error.message);
        } else {
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);
        }
        resolve(false);
      });
    });
  }

  openAppointmentDialog = (): void => {
    const appointmentConfig = new MatDialogConfig();
    appointmentConfig.panelClass = 'green-modal';
    appointmentConfig.maxWidth = '100vw';
    this.dialog.open(AppointmentModalComponent, appointmentConfig);
  }

  openFilterDialog = (): void => {
    const filterConfig = new MatDialogConfig();
    filterConfig.panelClass = 'green-modal';
    filterConfig.maxWidth = '100vw';
    this.dialog.open(FilterModalComponent, filterConfig);
  }

  changeTab(index: number): void {
    this.currentTab = index;
  }

  onTabChange($event: any) {
    let indexTab = $event.index;
    console.log('Tab: ', indexTab);
    if(indexTab === 0){
      this.changeTab(1);
      if(!!this.userType && (this.userType === 2 || this.userType === 3 || this.userType === 9)){
        this.document.location.href = environment.environmenturl + 'site/publicaciones';
      }else if (!!this.userType) {
        this.document.location.href = environment.environmenturl + '/projectpublishing/publicacionproyectos' ;
      }
    }
    if(indexTab == 2 || indexTab == 3) {
      window.location.href = environment.environmenturl + 'zona-privada/ofertas-realizadas'
    }
  }

  OpenOnboardingModal(Onboarding: any){
    console.log("event onboarding -->", Onboarding);

    this.dialogLogin.closeAll();
    if(Onboarding.modal == 1){
      console.log("Onboarding.modal-->", Onboarding.modal);
      this.OpenLoginModal(Onboarding.typeUser);
    }
    if(Onboarding.modal == 2){
      this.OpenRecoverPwModal(Onboarding.typeUser);
    }
    if(Onboarding.modal == 3){
      this.OpenRegisterModal(Onboarding.typeUser);
    }
  }

  OpenLoginModal(typeUser: string){
    let DialogRefLogin = this.dialogLogin.open(CcLoginComponent, {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });
    DialogRefLogin.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });

  }

  OpenRecoverPwModal(typeUser: string){
    let DialogRefRecover = this.dialogLogin.open(PasswordRecoverComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });
    DialogRefRecover.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

  OpenRegisterModal(typeUser: string){
    let DialogRefRegister = this.dialogLogin.open(CcRegisterComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });
    DialogRefRegister.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }
}
